import React from "react";
import { useTranslation } from "react-i18next";
import { useMoveListElement } from "@planzone/view-models";
import { Identifiable, List as L } from "@planzone/dto";

import { Checkbox } from "@common/checkbox";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { List } from "./list";
import { ProjectsSelection } from "./projectsSelection";
import { Props } from "./types";
import styles from "./styles.scss";

function MoveElement({
  project,
  currentParentList,
  projectElementType,
  projectElementId,
  cancel,
}: Props) {
  const { t } = useTranslation();
  const { isRequestPending, moveListElement } = useMoveListElement();
  const [nextParentList, setNextParentList] =
    React.useState<Identifiable<L> | null>(null);
  const [selectedProject, setSelectedProject] = React.useState(project);
  const [alignDates, setAlignDates] = React.useState(false);

  return (
    <Modal header={t("moveElement.title")} close={cancel}>
      <div className={styles.moveElement}>
        <div className={styles.body}>
          <ProjectsSelection
            projects={[selectedProject]}
            select={(projects) =>
              setSelectedProject(projects[projects.length - 1])
            }
          />
          <List
            project={selectedProject}
            projectElementType={projectElementType}
            projectElementId={projectElementId}
            nextParentList={nextParentList}
            setNextParentList={setNextParentList}
          />
          <div className={styles.conserveTime}>
            <div onClick={() => setAlignDates(!alignDates)}>
              <Checkbox isChecked={alignDates} />
            </div>
            <p className={styles.conserveTimeDescription}>
              {t(`moveElement.conserveTime.${projectElementType}`)}
            </p>
          </div>
        </div>
        <div className={styles.footer}>
          <Button type="cancel" press={cancel}>
            {t("moveElement.cancel")}
          </Button>
          <Button
            type="submit"
            status={isRequestPending ? "pending" : "none"}
            isDisabled={isRequestPending}
            press={() =>
              nextParentList &&
              moveListElement({
                nextParentList: nextParentList,
                currentParentList,
                projectElementType,
                projectElementId,
                range: {
                  max: null,
                  min: null,
                },
                alignDates,
              })
            }
          >
            {t("moveElement.submit")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { MoveElement };
